import {
  createAsyncThunk,
  createSlice,
  Draft,
  PayloadAction
} from "@reduxjs/toolkit";
import * as ClientService from "../../services/ClientService";
import { HttpCodes } from "../../constants/app.constant";
import { IFunctionsList } from "pages/JobPricing/Functions/types";
import { IGradesList } from "pages/JobPricing/Grades/types";
import { IJobsList } from "pages/JobPricing/Jobs/types";
// TODO: Fix import path if file exists, or define interfaces locally if not found
// import { IFunctionsList, IGradesList, IJobsList } from "../../helpers/models/JobPricingListModels";
export enum SJPRListTypes {
  JOBS = "job",
  FUNCTION = "function",
  GRADES = "grade"
}

const sampleJobs = [
  {
    id: 1,
    title: "Business Unit Leader HoS",
    grade: 21,
    jobFunction: 14,
    incumbents: 67
  },
  {
    id: 12,
    title: "Business Unit Leader HoS",
    grade: 21,
    jobFunction: 14,
    incumbents: 67
  },
  {
    id: 41,
    title: "Business Unit Leader HoS",
    grade: 21,
    jobFunction: 14,
    incumbents: 67
  },
  {
    id: 15,
    title: "Business Unit Leader HoS",
    grade: 21,
    jobFunction: 14,
    incumbents: 67
  }
];
const sampleFunctions = [
  {
    id: 1,
    name: "Product Development",
    totalJobs: 21,
    gradeSpan: 14,
    jobsInOrg: 33,
    incumbents: 67
  },
  {
    id: 2,
    name: "Human Resource",
    totalJobs: 21,
    gradeSpan: 14,
    jobsInOrg: 33,
    incumbents: 67
  },
  {
    id: 3,
    name: "Legal",
    totalJobs: 21,
    gradeSpan: 14,
    jobsInOrg: 33,
    incumbents: 67
  },
  {
    id: 11,
    name: "Product Development",
    totalJobs: 21,
    gradeSpan: 14,
    jobsInOrg: 33,
    incumbents: 67
  },
  {
    id: 22,
    name: "Human Resource",
    totalJobs: 21,
    gradeSpan: 14,
    jobsInOrg: 33,
    incumbents: 67
  },
  {
    id: 33,
    name: "Legal",
    totalJobs: 21,
    gradeSpan: 14,
    jobsInOrg: 33,
    incumbents: 67
  },
  {
    id: 14,
    name: "Product Development",
    totalJobs: 21,
    gradeSpan: 14,
    jobsInOrg: 33,
    incumbents: 67
  },
  {
    id: 25,
    name: "Human Resource",
    totalJobs: 21,
    gradeSpan: 14,
    jobsInOrg: 33,
    incumbents: 67
  },
  {
    id: 36,
    name: "Legal",
    totalJobs: 21,
    gradeSpan: 14,
    jobsInOrg: 33,
    incumbents: 67
  }
];
const sampleGrades = [
  {
    grade: 11,
    id: 32,
    incumbents: 55,
    jobsInOrg: 3,
    totalJobs: 222
  },
  {
    grade: 11,
    id: 33,
    incumbents: 55,
    jobsInOrg: 3,
    totalJobs: 222
  },
  {
    grade: 11,
    id: 34,
    incumbents: 55,
    jobsInOrg: 3,
    totalJobs: 222
  },
  {
    grade: 11,
    id: 35,
    incumbents: 55,
    jobsInOrg: 3,
    totalJobs: 222
  },
  {
    grade: 11,
    id: 36,
    incumbents: 55,
    jobsInOrg: 3,
    totalJobs: 222
  },
  {
    grade: 11,
    id: 37,
    incumbents: 55,
    jobsInOrg: 3,
    totalJobs: 222
  },
  {
    grade: 11,
    id: 38,
    incumbents: 55,
    jobsInOrg: 3,
    totalJobs: 222
  },
  {
    grade: 11,
    id: 39,
    incumbents: 55,
    jobsInOrg: 3,
    totalJobs: 222
  }
];
interface IJobPricingSlice {
  functionsList: IFunctionsList[];
  gradesList: IGradesList[];
  jobsList: IJobsList[];
  loading: boolean;
}

const initialState: IJobPricingSlice = {
  functionsList: [],
  loading: false,
  jobsList: [],
  gradesList: []
};

// single Job pricing main search thunk
export const JobPricingListThunk = createAsyncThunk(
  "jobpricingList/functionslist",
  async (type: string, thunkApi: any) => {
    try {
      const response2 = await ClientService.clientsSearch();
      const response: any = {
        responseCode: 200,
        data:
          type === SJPRListTypes.FUNCTION
            ? sampleFunctions
            : type === SJPRListTypes.JOBS
            ? sampleJobs
            : sampleGrades
      };
      if (response.responseCode === HttpCodes.SUCCESS) {
        return { type: type, data: response.data || [] };
      }
      return { type: type, data: [] };
    } catch (e) {
      console.log(e);
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const jobPricingListSlice = createSlice({
  name: "jobpricingList",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(JobPricingListThunk.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(JobPricingListThunk.fulfilled, (state, action) => {
      switch (action.payload.type) {
        case SJPRListTypes.FUNCTION:
          state.functionsList = action.payload.data;
          break;
        case SJPRListTypes.JOBS:
          state.jobsList = action.payload.data;
          break;
        case SJPRListTypes.GRADES:
          state.gradesList = action.payload.data;
          break;
        default:
          break;
      }
      // state.functionsList = action.payload.data;
      // action.payload.type === SJPRListTypes.FUNCTION
      //   ? sampleFunctions
      //   : type === SJPRListTypes.JOBS
      //   ? sampleJobs
      //   : sampleGrades;
      state.loading = false;
    });
    builder.addCase(JobPricingListThunk.rejected, (state, action) => {
      state.loading = false;
      state.functionsList = [];
    });
  }
});

export const {} = jobPricingListSlice.actions;

export default jobPricingListSlice.reducer;
